import Vue from 'vue';
import WebifyImage from "./components/WebifyImage";

window.axios = require('axios');

Vue.component(WebifyImage.name, WebifyImage);
if (document.body.contains(document.getElementById('app'))) {
    const app = new Vue({
        el: '#app',
    });
}